import { ModalProps } from '@/types/shared'
import { Button, Dialog, Typogaphy } from 'vnetwork-ui'

export interface MetadataModalProps extends ModalProps {
    metadata: object | string | number
}

const MetadataModal: React.FC<MetadataModalProps> = ({
    onClose,
    open,
    metadata,
}) => {
    const DrawData = (data: object | string | number) => {
        if (typeof data === 'object') {
            return (
                <>
                    {Object.entries(data).map(([key, value]) => (
                        <div
                            key={key}
                            className="grid grid-cols-2 gap-1 m-1 items-center"
                        >
                            <div className="p-2 rounded">{key}:</div>
                            <div className="p-2 rounded">{DrawData(value)}</div>
                        </div>
                    ))}
                </>
            )
        }
        if (typeof data === 'boolean') {
            return (
                <Typogaphy size="small" className="text-gray-500">
                    {data ? 'True' : 'False'}
                </Typogaphy>
            )
        }
        return (
            <Typogaphy size="small" className="text-gray-500">
                {data}
            </Typogaphy>
        )
    }
    return (
        <Dialog
            onClose={onClose}
            open={open}
            title={'Thông tin chi tiết'}
            className="overflow-y-auto max-h-[calc(100vh-200px)] overflow-x-auto"
            actions={
                <div className="flex items-center gap-2">
                    <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button>
                </div>
            }
        >
            <div>{DrawData(metadata)}</div>
        </Dialog>
    )
}

export default MetadataModal
